import get from 'lodash-es/get';

/**
 * Используются для динамического иморта карты на страницу
 * @example
 * Есть два способа использование: Оба способа после инициализации записывает в window.Block.DeliveryMap конструктор
 * 1. Получение через then
 *	window.ImportBlock.DeliveryMap().then((DeliveryMap) => {
 *		new DeliveryMap(...);
 *	})
 * 2. Через await (требуется обёртка в async функцию)
 * 	const DeliveryMap = await window.ImportBlock.DeliveryMap();
 * 	new DeliveryMap(...);
 * @return {Promise<DeliveryMap>} - Возвращает импортируемый класс если есть хотя бы одна карта на странице
 */
window.ImportBlock.DeliveryMap = async () => {
	if (window.Block.DeliveryMap) return window.Block.DeliveryMap;
	const item = document.querySelector('.delivery-map:not(.delivery-map_inited)');
	if (item) {
		const { DeliveryMap } = await import(/* webpackChunkName: "Map" */ './delivery-map.module');
		window.Block.DeliveryMap = DeliveryMap;
		return DeliveryMap;
	}
};

/**
 * Метод инициализации класса карты с доставкой. Импортирует карту и инициализирует блок
 * @param data
 * @return {Promise<*>}
 */
window.Loading.DeliveryMap = async (data) => {
	const elem = get(data, 'elem');
	if (elem?.AsyncDeliveryMap) return await elem?.AsyncDeliveryMap;

	const DeliveryMap = await window.ImportBlock.DeliveryMap();
	const block = new DeliveryMap(data);
	return await block.block?.AsyncDeliveryMap;
};

if (NOT_PROD) {
	window.ImportBlock.DeliveryMap().then((DeliveryMap) => {
		import('./data').then(({ data }) => {
			DeliveryMap?.init({ options: { resellers: data.resellers } });
		});
	});
}
